import React from "react";
import { Html } from "react-konva-utils";

function getStyle(width, height,color,tamanio) {
  const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
  const baseStyle = {
    width: `${width}px`,
    height: `${height}px`,
    border: "none",
    padding: "0px",
    margin: "0px",
    background: "none",
    outline: "none",
    resize: "none",
    fontSize: tamanio,
    fontFamily: "sans-serif",
    fontWeight:'bold',
    color:color? color : "#000000",
  };
  if (isFirefox) {
    return baseStyle;
  }
  return {
    ...baseStyle,
    margintop: "-4px"
  };
}

export function TextoEditado({x,y,width,height,value,onChange,onKeyDown,color,tamanio}) {
  const style = getStyle(width, height,color,tamanio);
  return (
    <Html groupProps={{ x, y }} divProps={{ style: { opacity: 1 } }}>
      <textarea
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        style={style}
      />
    </Html>
  );
}
